import { types } from 'mobx-state-tree';

export default types
  .model('LoginSignupDialogState', {
    showForm: types.optional(types.string, 'login'),
    error: types.maybeNull(types.boolean),
    safariWarning: types.optional(types.boolean, false),
    showButtonsOnly: types.optional(types.boolean, false),
  })
  .views(self => ({
    get hasError() {
      return !!self.error;
    },
  }))
  .actions(self => ({
    toggleDisplay() {
      self.showForm = self.showForm === 'login' ? 'signup' : 'login';
      return self;
    },
    setShowForm(showForm) {
      self.showForm = showForm;
      return self;
    },
    setError(error) {
      error === 'popup_blocked_by_browser' ? self.safariWarning = true : self.error = error;
      return self;
    },
    clearError() {
      self.error = null;
      return self;
    },
    getSafariWarning() {
      return self.safariWarning;
    },
    closeSafariWarning() {
      self.safariWarning = false;
      return self;
    },
  }));
